export type WorkspaceViewType = 'all' | 'mine' | 'group';

export interface WorkspaceView {
  type: WorkspaceViewType;
  supportGroupId?: string | null;
  label: string;
}

export const createAllView = (): WorkspaceView => ({
  type: 'all',
  label: 'Todas as conversas',
});

export const createMyView = (): WorkspaceView => ({
  type: 'mine',
  label: 'Minhas conversas',
});

export const createGroupView = (supportGroupId: string, supportGroupName: string): WorkspaceView => ({
  type: 'group',
  supportGroupId,
  label: `Grupo: ${supportGroupName}`,
});
